import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './DummyDashboard.css';

const DummyDashboard = () => {
  const { currentUser, hasPermission } = useAuth();
  const navigate = useNavigate();

  const name = currentUser?.name || currentUser?.email || 'User';
  const role = typeof currentUser?.role === 'string'
    ? currentUser.role.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    : currentUser?.role?.name || 'Employee';

  const today = new Date().toLocaleDateString('en-IN', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });

  const quickLinks = [
    { label: 'My Tasks',       icon: 'fa-tasks',          path: '/task',        permission: 'task_view' },
    { label: 'My Leaves',      icon: 'fa-calendar-minus', path: '/leave',       permission: 'leave_view' },
    { label: 'Attendance',     icon: 'fa-user-check',     path: '/attendance',  permission: 'attendance_view' },
    { label: 'Documents',      icon: 'fa-file-alt',       path: '/document',    permission: 'document_view' },
    { label: 'Performance',    icon: 'fa-chart-bar',      path: '/performance', permission: 'performance_view' },
    { label: 'Payroll',        icon: 'fa-money-bill-wave',path: '/payroll',     permission: 'payroll_view' },
  ].filter(link => hasPermission(link.permission));

  const personalStats = [
    { icon: 'fa-calendar-check', label: 'Working Days This Month', value: '22', color: 'blue' },
    { icon: 'fa-user-check',     label: 'Days Present',            value: '19', color: 'green' },
    { icon: 'fa-calendar-minus', label: 'Leaves Taken',            value: '2',  color: 'orange' },
    { icon: 'fa-tasks',          label: 'Pending Tasks',           value: '5',  color: 'red' },
  ];

  const announcements = [
    { icon: 'fa-bullhorn', text: 'Office will remain closed on March 25th (public holiday).', time: 'Today' },
    { icon: 'fa-gift',     text: 'Employee of the Month announcement coming soon!',            time: '2 days ago' },
    { icon: 'fa-info-circle', text: 'New leave policy effective from April 1st.',              time: '3 days ago' },
  ];

  return (
    <div className="dummy-dashboard">
      {/* Welcome Banner */}
      <div className="welcome-banner">
        <div className="welcome-text">
          <h2>Welcome back, <span>{name}</span> 👋</h2>
          <p>{today}</p>
          <span className="role-badge">{role}</span>
        </div>
        <div className="welcome-illustration">
          <i className="fas fa-user-circle"></i>
        </div>
      </div>

      {/* Personal Stats */}
      <div className="dummy-stats-grid">
        {personalStats.map((stat, i) => (
          <div key={i} className="dummy-stat-card">
            <div className={`dummy-stat-icon ${stat.color}`}>
              <i className={`fas ${stat.icon}`}></i>
            </div>
            <div className="dummy-stat-info">
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="dummy-bottom-grid">
        {/* Quick Links */}
        {quickLinks.length > 0 && (
          <div className="dummy-card">
            <h3 className="dummy-card-title">
              <i className="fas fa-th-large"></i> Quick Access
            </h3>
            <div className="quick-links-grid">
              {quickLinks.map((link, i) => (
                <button key={i} className="quick-link-btn" onClick={() => navigate(link.path)}>
                  <i className={`fas ${link.icon}`}></i>
                  <span>{link.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Announcements */}
        <div className="dummy-card">
          <h3 className="dummy-card-title">
            <i className="fas fa-bullhorn"></i> Announcements
          </h3>
          <div className="announcement-list">
            {announcements.map((item, i) => (
              <div key={i} className="announcement-item">
                <div className="announcement-icon">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <div className="announcement-body">
                  <p>{item.text}</p>
                  <span>{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Today's Schedule */}
        <div className="dummy-card">
          <h3 className="dummy-card-title">
            <i className="fas fa-calendar-day"></i> Today's Schedule
          </h3>
          <div className="schedule-list">
            <div className="schedule-item">
              <span className="schedule-time">09:00 AM</span>
              <span className="schedule-desc">Daily Standup</span>
            </div>
            <div className="schedule-item">
              <span className="schedule-time">11:00 AM</span>
              <span className="schedule-desc">Team Review Meeting</span>
            </div>
            <div className="schedule-item">
              <span className="schedule-time">02:00 PM</span>
              <span className="schedule-desc">Client Call</span>
            </div>
            <div className="schedule-item">
              <span className="schedule-time">05:00 PM</span>
              <span className="schedule-desc">End of Day Report</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DummyDashboard;
